import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { XMarkIcon } from "@heroicons/react/24/solid";
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";

const ProfileDetails = () => {
  const { t, i18n } = useTranslation();
  const { state } = useLocation();
  const profile = state?.profile;
  const navigate = useNavigate();

  if (!profile) {
    return (
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
        <div className="bg-white rounded-xl max-w-md w-full p-6 text-center">
          <p className="text-gray-600">{t("profileDetails.noProfileData")}</p>
        </div>
      </div>
    );
  }

  const handleLanguageChange = (e) => {
    i18n.changeLanguage(e.target.value === "english" ? "en" : "ta");
    localStorage.setItem(
      "language",
      e.target.value === "english" ? "en" : "ta",
    );
  };

  const handleProfileClick = () => {
    const profileCode = profile.id;
    console.log("Profile Code:", profileCode);
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
      >
        <motion.div
          initial={{ scale: 0.9, y: 20 }}
          animate={{ scale: 1, y: 0 }}
          exit={{ scale: 0.9, y: 20 }}
          transition={{ type: "spring", stiffness: 300, damping: 20 }}
          className="bg-white rounded-xl max-w-md w-full p-6 transform transition-all duration-300 ease-in-out shadow-2xl"
        >
          <div className="flex justify-between items-start mb-4">
            <h2 className="text-2xl font-bold text-[#e67e22]">
              {t("profileDetails.profileDetails")}
            </h2>
            <button
              onClick={() => navigate(-1)}
              className="p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
            >
              <XMarkIcon className="h-6 w-6 text-gray-700 hover:text-red-500" />
            </button>
          </div>

          <div className="mb-4">
            <label
              htmlFor="language"
              className="block text-sm font-medium text-gray-700"
            >
              {t("profileDetails.language")}
            </label>
            <select
              id="language"
              name="language"
              value={i18n.language === "en" ? "english" : "tamil"}
              onChange={handleLanguageChange}
              className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-[#e67e22] focus:border-[#e67e22] sm:text-sm rounded-md"
            >
              <option value="english">{t("languages.english")}</option>
              <option value="tamil">{t("languages.tamil")}</option>
            </select>
          </div>

          <div
            className="flex flex-col items-center gap-4 cursor-pointer"
            onClick={handleProfileClick}
          >
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="relative w-32 h-32 rounded-full overflow-hidden shadow-lg"
            >
              <img
                src={
                  profile.photo_base64
                    ? `data:image/png;base64,${profile.photo_base64}`
                    : "https://via.placeholder.com/150"
                }
                alt={profile.full_name}
                className="w-full h-full object-cover"
              />
            </motion.div>
            <div className="text-center">
              <h3 className="text-2xl font-bold text-gray-900">
                {profile.full_name}
              </h3>
              <p className="text-sm text-gray-600 mt-1">{profile.occupation}</p>
            </div>
          </div>

          <div className="mt-6 space-y-4">
            <div className="bg-gray-50 p-4 rounded-lg">
              <h4 className="text-sm font-semibold text-gray-700">
                {t("profileDetails.education")}
              </h4>
              <p className="text-sm text-gray-600 mt-1">
                {profile.education || t("profileDetails.notSpecified")}
              </p>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg">
              <h4 className="text-sm font-semibold text-gray-700">
                {t("profileDetails.ageGender")}
              </h4>
              <p className="text-sm text-gray-600 mt-1">
                {profile.age} years • {profile.gender}
              </p>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg">
              <h4 className="text-sm font-semibold text-gray-700">
                {t("profileDetails.about")}
              </h4>
              <p className="text-sm text-gray-600 mt-1">
                {profile.bio || t("profileDetails.noInfo")}
              </p>
            </div>
          </div>

          <div className="mt-6 flex justify-center gap-4">
            <button
              onClick={() => navigate(-1)}
              className="px-6 py-2 bg-gradient-to-r from-[#e67e22] to-[#d35400] text-white rounded-lg hover:from-[#f39c12] hover:to-[#e67e22] transition-all duration-200 shadow-lg"
            >
              {t("profileDetails.close")}
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ProfileDetails;
